<template>
<div>
 <!-- Testimonials -->
      <div class="g-bg-main-light-v2">
        <div class="container g-py-20">
          <carousel :perPageCustom="[[280, 1], [768, 1]]" :autoplay="true" :loop="true" :autoplayTimeout="10000" class="js-carousel" data-pagi-classes="u-carousel-indicators-v35--white g-pos-rel text-center">
        <!-- Testimonials -->
        <slide>
            <div class="row justify-content-lg-center">
              <div class="col-md-12 col-lg-10">
                  <!-- Testimonials - Content -->
                  <div class="media mb-3">
                    <div class="d-flex mr-3">
                        <span class="g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10">&#8220;</span>
                    </div>
                    <div class="media-body">
                        <blockquote class="g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0">Simply put, Changing Life through Lenses® has significantly expanded our ability to serve the underserved with the gift of sight.  I can not overstate how critical this is to those suffering in our community.
                        <span class="align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10">&#8221;</span>
                        </blockquote>
                    </div>
                  </div>

                  <div class="g-pl-30">
                    <h3 class="h4  g-font-size-18 g-color-white-opacity-0_9 mb-0">Rupert C. Chowins, O.D.</h3>
                    <span class="d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20">&#8212; Eye Clinic Director, SLO Noor Free Clinic</span>
                  </div>
                  <!-- End Testimonials - Content -->
              </div>
            </div>
        </slide>
        <!-- End Testimonials -->

        <!-- Testimonials -->
        <slide>
          <div class="row justify-content-lg-center g-mb-20">
            <div class="col-md-12 col-lg-10 g-mb-20">
                <!-- Testimonials - Content -->
                <div class="media mb-3">
                  <div class="d-flex mr-3">
                      <span class="g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10">&#8220;</span>
                  </div>
                  <div class="media-body">
                      <blockquote class="g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0">A friend (also an OD) and I have been using your program to provide glasses to the homeless in Philadelphia. We have felt drawn to help this population on a pro bono basis for a long time and now we can provide them with no cost quality vision correction!  Many times, those who are materially poor do not have many choices, so it is wonderful to have such a terrific selection of stylish and quality frames to offer them. They were so pleased and excited!
                      <span class="align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10">&#8221;</span>
                      </blockquote>
                  </div>
                </div>

                <div class="g-pl-30">
                  <h3 class="h4 g-font-size-18 g-color-white-opacity-0_9 mb-0">Christine Chmielewski, O.D.</h3>
                </div>
                <!-- End Testimonials - Content -->
            </div>
          </div>
        </slide>
                <!-- Testimonials -->
        <slide>
          <div class="row justify-content-lg-center g-mb-20">
            <div class="col-md-12 col-lg-10 g-mb-20">
                <!-- Testimonials - Content -->
                <div class="media mb-3">
                  <div class="d-flex mr-3">
                      <span class="g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10">&#8220;</span>
                  </div>
                  <div class="media-body">
                      <blockquote class="g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0">For almost 15 years, we have been setting aside four exam slots per month for Howard Brown Health Center patients. The cost of providing high quality eye wear kept us from being able to offer even more services. Changing Life through Lenses® makes ordering easy, the glasses are high quality and are provided in a timely manner.  Now that the cost of the eye wear is not an obstacle, we are able to open up our services to more patients.
                      <span class="align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10">&#8221;</span>
                      </blockquote>
                  </div>
                </div>

                <div class="g-pl-30">
                  <h3 class="h4 g-font-size-18 g-color-white-opacity-0_9 mb-0">Michael Ciszek, O.D.</h3>
                  <span class="d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20">&#8212; Visionary Eye Care Professionals</span>

                </div>
                <!-- End Testimonials - Content -->
            </div>
          </div>
        </slide>
        <!-- End Testimonials -->

        <!-- Testimonials -->
        <slide>
          <div class="row justify-content-lg-center g-mb-20">
            <div class="col-md-12 col-lg-10 g-mb-20">
                <!-- Testimonials - Content -->
                <div class="media mb-3">
                  <div class="d-flex mr-3">
                      <span class="g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10">&#8220;</span>
                  </div>
                  <div class="media-body">
                      <blockquote class="g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0">This effort has the potential to make a real impact on a large number of kids in underserved communities across the U.S. – all of us here at HKI are super excited!
                      <span class="align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10">&#8221;</span>
                      </blockquote>
                  </div>
                </div>

                <div class="g-pl-30">
                  <h3 class="h4 g-font-size-18 g-color-white-opacity-0_9 mb-0">Meghan K. Lynch</h3>
                  <span class="d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20">&#8212; Director, ChildSight® U.S. Helen Keller International
                  </span>
                </div>
                <!-- End Testimonials - Content -->
            </div>
          </div>
        </slide>
        <!-- End Testimonials -->

        <!-- Testimonials -->
        <slide>
          <div class="row justify-content-lg-center g-mb-20">
            <div class="col-md-12 col-lg-10 g-mb-20">
                <!-- Testimonials - Content -->
                <div class="media mb-3">
                  <div class="d-flex mr-3">
                      <span class="g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10">&#8220;</span>
                  </div>
                  <div class="media-body">
                      <blockquote class="g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0">Our patients are always so pleased when they hear that we are doing charitable giving and we always give CLTL the credit! It's definitely a great practice builder -- do what's right for the patient and it'll always help your practice. It also makes the staff happy to see we are helping patients at no charge to them. It makes them feel like they are part of something special and shows that the goal of the practice is to help people. Of course, they know that we need to make money to keep the doors open, but it's not about that, it's about the patients.
                      <span class="align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10">&#8221;</span>
                      </blockquote>
                  </div>
                </div>

                <div class="g-pl-30">
                  <h3 class="h4 g-font-size-18 g-color-white-opacity-0_9 mb-0">Dr. Suzanne Zamberlan of Evergreen</h3>
                  <span class="d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20">&#8212; Eye Care in Vancouver, WA
                    <!-- <a href="http://www.visionispriceless.org" target="_blank" class="g-color-white-opacity-0_5 g-font-size-18--md g-font-size-14">Vision Is Priceless</a> -->
                  </span>
                </div>
                <!-- End Testimonials - Content -->
            </div>
          </div>
        </slide>
        <!-- End Testimonials -->
          </carousel>
        </div>
      </div>
      <!-- End Testimonials -->
</div>
</template>
<script>
export default {
  data() {
    return {
       swiperOption: {
         slidesPerView: 1
       }
    }
  }
}
</script>



// WEBPACK FOOTER //
// HomeBlock.vue?12290576